import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-buttons',
  templateUrl: './form-buttons.component.html',
  styleUrl: './form-buttons.component.css'
})
export class FormButtonsComponent {
  @Input() botonProcesando: boolean;
  @Input() buttonCancelId: string;
  @Input() labelCancel: string;
  @Input() buttonSaveId: string;
  @Input() frm: FormGroup;
  @Input() labelSave: string;
  @Input() labelLoading: string;
  @Input() icon:string;
  @Input() validate?:boolean;
  @Output() cancel?: EventEmitter<any> = new EventEmitter<any>();

  clickCancelButton()
  {
    
    if(this.cancel.observed) {
      this.cancel.emit();
    }
  }
}
